import React, { Fragment, useState, useEffect } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import BotChatGPT from '../ChatbotPopUp';
import Logo from "../../images/caobangceritage.svg"
import './HuongDanPage.style.css';
import s1_1 from '../../images/huongdan/new/s1-1.png';
import s1_2 from '../../images/huongdan/s1-2.png';
import s1_3 from '../../images/huongdan/s1-3.png';
import s2_1 from '../../images/huongdan/new/s2-1.png';
import s2_2 from '../../images/huongdan/s2-2.png';
import s2_3 from '../../images/huongdan/s2-3.png';
import s3_1 from '../../images/huongdan/s3-1.png';
import s3_2 from '../../images/huongdan/s3-2.png';
import s4_1 from '../../images/huongdan/new/s4-1.png';
import s4_2 from '../../images/huongdan/new/s4-2.png';
import s4_3 from '../../images/huongdan/s4-3.png';
import s4_4 from '../../images/huongdan/s4-4.png';
import s4_5 from '../../images/huongdan/s4-5.png';
import s5_1 from '../../images/huongdan/new/s5-1.png';
import s5_2 from '../../images/huongdan/s5-2.png';
import s5_3 from '../../images/huongdan/s5-3.png';
import s6_1 from '../../images/huongdan/new/s6-1.png';
import s6_2 from '../../images/huongdan/s6-2.png';
import s6_3 from '../../images/huongdan/s6-3.png';
import s6_4 from '../../images/huongdan/new/s6-4.png';
import s7_1 from '../../images/huongdan/new/s7-1.png';
import s7_2 from '../../images/huongdan/new/7-2.png';
import s7_3 from '../../images/huongdan/s7-3.png';
import s7_4 from '../../images/huongdan/s7-4.png';
import s8_1 from '../../images/huongdan/s8-1.png';
import s8_2 from '../../images/huongdan/s8-2.png';
import s8_3 from '../../images/huongdan/s8-3.png';
import AiVoice from '../../components/AiVoice/AiVoice';

const guideSections = [
    {
        title: 'AI Tạo Họa tiết Vải – Sáng tạo không giới hạn',
        content: [
            { text: '<b>Bước 1:</b> Truy cập tính năng từ trang chủ, chọn mục "Thiết kế cùng AI".', image: s1_1, width: 1000 },
            { text: '<b>Bước 2:</b> Tùy chỉnh thiết kế: chọn màu sắc, hình dạng, kiểu vẽ.', image: s1_2, width: 600 },
            { text: '<b>Bước 3:</b> Nhấn "Tạo họa tiết" để AI tạo mẫu, trò chuyện với AI để tinh chỉnh hoặc hỏi ý nghĩa họa tiết.', image: s1_3, width: 600 }
        ]
    },
    {
        title: 'AI Nhận diện Họa tiết ',
        content: [
          { text: '<b>Bước 1:</b> Truy cập tính năng từ trang chủ, chọn mục "AI Nhận diện.', image: s2_1, width: 1000 },
            { text: '<b>Bước 2:</b> Ở đây, bạn có thể chụp ảnh hoặc tải ảnh họa tiết (jpg/png, dưới 5MB).', image: s2_2, width: 600 },
            { text: '<b>Bước 3:</b> Sau khi AI nhận diện, bạn có thể trò chuyện với chatbot để hỏi về kỹ thuật, ý nghĩa, lịch sử họa tiết, hướng đẫn dệt vải dựa trên họa tiết.', image: s2_3, width: 600 }
        ]
    },
    {
      title: 'Chatbot Văn hóa – Trợ lý ảo Thông minh',
      content: [
          { text: '<b>Bước 1:</b> Bạn hãy chọn vào icon Chatbot ở phía dưới bên phải.', image: s3_1, width: 300 },
          { text: '<b>Bước 2:</b> Sau khi nhập tên, bạn có thể trò chuyện với chatbot để hỏi về kỹ thuật, ý nghĩa, lịch sử họa tiết.', image: s3_2, width: 300  }
      ]
  },
    {
        title: 'Khu Tham quan 360 – Đắm mình trong Không gian Văn hóa Số',
        content: [
          { text: '<b>Bước 1:</b> Truy cập tính năng từ trang chủ, chọn mục "360', image: s4_1, width: 1000 },
            { text: '<b>Bước 2:</b> Tiến hành chọn các khu vực tham quan được giới thiệu trên trang.', image: s4_2, width: 600 },
            { text: '<b>Bước 3:</b> Tiến hành chọn các khu vực tham quan được giới thiệu trên trang.', image: s4_3, width: 600 },
            { text: '<b>Bước 4:</b> Sử dụng chuột (hoặc chạm trên màn hình cảm ứng) để xoay và xem toàn cảnh không gian 360 độ.', image: s4_4, width: 600 },
            { text: '<b>Bước 5:</b> Bạn có thể "di chuyển" giữa các điểm tham quan khác nhau.', image: s4_5, width: 600 }
        ]
    },
    {
        "title": "Thư viện số – Kho tàng Tri thức Di sản",
        "content": [
          { "text": "<b>Bước 1:</b> Từ thanh điều hướng chính, chọn mục <b>\"Bài nghiên cứu\"</b> hoặc <b>\"Khoảnh khắc\"</b> để truy cập kho tàng di sản số của CaoBangCeritage.", image: s5_1, width: 1000 },
          { "text": "<b>Bước 2:</b> Khám phá các chuyên mục được phân loại khoa học theo <b>dân tộc, loại họa tiết, và kỹ thuật dệt</b> để tìm kiếm thông tin bạn quan tâm.", image: s5_2, width: 600 },
          { "text": "<b>Bước 3:</b> Nhấn vào một bài viết hoặc hình ảnh để xem nội dung chi tiết, đọc các mô tả sâu sắc và tìm hiểu về lịch sử, ý nghĩa đằng sau mỗi di sản.", image: s5_3, width: 600 }
        ]
    },
    {
        "title": "Khám phá Sản phẩm và Liên hệ Người bán",
        "content": [
          { "text": "<b>Bước 1:</b> Từ thanh điều hướng chính, chọn mục <b>\"Sản phẩm\"</b> để xem danh sách các mặt hàng thủ công độc đáo của Cao Bằng.", image: s6_1, width: 1000 },
          { "text": "<b>Bước 2:</b> Bạn có thể sử dụng thanh <b>\"Tìm kiếm sản phẩm...\"</b> hoặc bộ lọc (Vải thổ cẩm, Khăn, Túi) để nhanh chóng tìm thấy món đồ mình yêu thích.", image: s6_2, width: 600 },
          { "text": "<b>Bước 3:</b> Nhấn vào nút <b>\"Xem chi tiết\"</b> ở sản phẩm bạn quan tâm để tìm hiểu thêm.", image: s6_3, width: 600  },
          { "text": "<b>Bước 4:</b> Tại trang chi tiết, hãy đọc <b>\"Câu chuyện sản phẩm\"</b> để hiểu về giá trị văn hóa và tâm huyết của người nghệ nhân. Thông tin người bán bao gồm <b>Họ tên, SDT và Địa chỉ</b> được cung cấp rõ ràng để bạn có thể trực tiếp liên hệ.", image: s6_4, width: 600  }
        ]
      },
      {
        "title": "Kiểm tra Kiến thức qua Bài trắc nghiệm",
        "content": [
          { "text": "<b>Bước 1:</b> Truy cập mục <b>\"Trắc nghiệm\"</b> trên thanh điều hướng để thử thách hiểu biết của bạn về dự án và văn hóa Cao Bằng.", image: s7_1, width: 1000 },
          { "text": "<b>Bước 2:</b> Chọn một trong các đề có sẵn (từ Đề 1 đến Đề 6) và nhấn nút <b>\"Bắt đầu\"</b>.", image: s7_2, width: 600 },
          { "text": "<b>Bước 3:</b> Đọc kỹ câu hỏi và chọn một đáp án (A, B, C, hoặc D) mà bạn cho là đúng.", image: s7_3, width: 600 },
          { "text": "<b>Bước 4:</b> Sử dụng các nút mũi tên ở phía dưới để di chuyển qua lại giữa 15 câu hỏi. Bạn có thể thay đổi câu trả lời của mình bất cứ lúc nào trước khi hoàn thành.", image: s7_4, width: 600 }
        ]
      },
      {
        "title": "Trò chuyện cùng Trợ lý AI",
        "content": [
          { "text": "<b>Bước 1:</b> Ở góc dưới bên trái màn hình, bạn sẽ thấy một biểu tượng với dòng chữ \"Hãy trò chuyện với tôi\". Hãy nhấn vào nút <b>\"Bắt đầu\"</b>.", image: s8_1, width: 1000 },
          { "text": "<b>Bước 2:</b> Một giao diện trò chuyện sẽ hiện ra. Bạn hãy nhấn vào icon  <b>\"Call\"</b> để tiến hành hội thoại.", image: s8_2, width: 600 },
          { "text": "<b>Bước 3:</b> Hãy hỏi Trợ lý AI bất cứ điều gì bạn thắc mắc, từ việc hướng dẫn sử dụng một tính năng, giải thích về một họa tiết, cho đến tìm hiểu sâu hơn về văn hóa vải, họa tiết.", image: s8_3, width: 600 }
        ]
      }
];

const AccordionItem = ({ section, isOpen, onToggle }) => {
    return (
        <div className={`accordion-item ${isOpen ? 'open' : ''}`}>
            <div className="accordion-header" onClick={onToggle}>
                <h3>{section.title}</h3>
                <span className="icon">{isOpen ? '−' : '+'}</span>
            </div>
            <div className="accordion-content">
                <ul>
                    {section.content.map((item, index) => (
                        <li key={index}>
                            <span dangerouslySetInnerHTML={{ __html: item.text }} />
                            {item.image && (
                                <img
                                    src={item.image}
                                    alt={section.title + ' - Bước ' + (index + 1)}
                                    className="guide-image"
                                    style={{
                                        width: item.width ? item.width : undefined,
                                        height: item.height ? item.height : undefined,
                                        maxWidth: '100%',
                                        display: 'block',
                                        margin: '0 auto 1.5rem auto'
                                    }}
                                />
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

const HuongDanPage = () => {
    const [openIndexes, setOpenIndexes] = useState([0]);

    useEffect(() => {
        document.body.classList.add('huongdan-active');
        return () => {
            document.body.classList.remove('huongdan-active');
        };
    }, []);

    const handleToggle = (index) => {
        setOpenIndexes(
            openIndexes.includes(index)
                ? openIndexes.filter((i) => i !== index)
                : [...openIndexes, index]
        );
    };

    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <div className="huongdan-container" style={{ maxWidth: 1300, margin: '2rem auto', padding: '24px' }}>
                <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
                    <h1>Giới thiệu Trang web CaoBangCeritage</h1>
                    <p style={{ fontSize: '1.2rem', color: '#555' }}>Nơi di sản văn hóa gặp gỡ công nghệ hiện đại</p>
                </div>
                <div className="intro-section" style={{ marginBottom: '3rem', lineHeight: '1.7' }}>
                    <p>
                        Chào mừng bạn đến với <b>CaoBangCeritage</b>, một dự án đột phá với sứ mệnh kết nối văn hóa truyền thống của Cao Bằng với sức mạnh của công nghệ. Trong bối cảnh văn hóa truyền thống, đặc biệt là các họa tiết vải dân tộc, đang dần mai một, CaoBangCeritage ra đời như một giải pháp số, giúp bảo tồn, lan tỏa và làm sống lại những giá trị di sản quý báu này trong cộng đồng, đặc biệt là thế hệ trẻ.
                    </p>
                    <p>
                        <b>Mục tiêu</b> của CaoBangCeritage là truyền cảm hứng học tập và sáng tạo, giúp thế hệ trẻ tiếp cận và yêu mến di sản văn hóa dân tộc thông qua một ngôn ngữ công nghệ gần gũi và hiện đại.
                    </p>
                </div>
                <div className="accordion-section">
                    <h2 style={{ textAlign: 'center', marginBottom: '2rem' }}>Hướng dẫn Sử dụng các Tính năng</h2>
                    {guideSections.map((section, index) => (
                        <AccordionItem
                            key={index}
                            section={section}
                            isOpen={openIndexes.includes(index)}
                            onToggle={() => handleToggle(index)}
                        />
                    ))}
                </div>
                <p style={{marginTop: 32, fontStyle: 'italic', color: '#555', textAlign: 'center'}}>Dự án được phát triển bởi nhóm học sinh tài năng: Hoàng Đức Mạnh, Hoàng Hải Nam, Văn Hoàng Đăng Tâm, Lã Việt Hùng, và Văn Hoàng Minh Khuê, với sự hướng dẫn của giáo viên Vương Thùy Dung.</p>
            </div>
            <Footer />
            <AiVoice />
            <BotChatGPT />
        </Fragment>
    );
};

export default HuongDanPage; 